import React, { useContext } from 'react';
import { Box } from '@mui/material';
import Sidebar from '_lex/_atoms/Sidebar';
import { AppContext } from '../../context';

export type MainNavProps = {};

const MainNav: React.FC<MainNavProps> = () => {
  const { sidebarItems } = useContext(AppContext);

  return (
    <Box
      className='left-nav-container'
      sx={{
        position: 'relative',
        height: '100%',
        gridRow: '1 / -1',
      }}
    >
      <Sidebar items={sidebarItems} />
    </Box>
  );
};

export default MainNav;
